import React, { Component, PropTypes } from 'react';
// import { Link } from 'react-router';
// import { accountRoute } from '../../../routes';
import baseUrl from '../../../utils/baseUrl';
import axios from 'axios';

import ContentBlock from '../block/content';

import Form from '../../form/form';
import InputText from '../../form/input/text';
import InputCheckbox from '../../form/input/checkbox';
import Label from '../../form/label';
import Select from '../../form/select/select';
import InputSubmit from '../../form/input/submit';

import FormFitter from '../../form/decorators/formfitter';

import GenericStep from './stepGeneric';
import translate from '../../../utils/translate';

import cc1 from './cc1.png';
import cc2 from './cc2.png';
import cc3 from './cc3.png';
import cc4 from './cc4.png';
import countriesJSONPath from '../../../utils/json/countries.json';

export default class AccountJobCreateStep2 extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		skipPayment: PropTypes.bool,
		activeStep: PropTypes.number.isRequired,
		onSubmit: PropTypes.func.isRequired,
	};

	static defaultProps = {
		active: false,
		onSubmit: function(promise) { promise.then(() => {}).catch(() => {}); },
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			submitting: false,
			showVAT: false,
			showVoucher: false,
		};
	}

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let path = '/api/account/jobs/create/info';
		let smallAside = true;

		return (
			<GenericStep
				active={(this.props.activeStep === 2)}
				stepNumber='02'
				stepTitle='Submitter’s info'
				summary={this.renderSummary()}
			>
				<Form getRefs={() => this.getRefs()} ref='form' action={path} smallAside={smallAside} onSubmit={this.onSubmit.bind(this)} dispatch={this.props.dispatch}>
					<ContentBlock title='Information' smallAside={smallAside}>
						<FormFitter className='span3 span5-tablet span11-mobile'>
							<InputText ref='contact' name='contact' label='Contact' btw='' />
							<InputText ref='email' name='email' label='Email' btw=" (for this submission's correspondence)" />
							<InputText ref='company' name='company' label='Company name' btw=' (optional)' />
							<Label label='Country' />
							<Select
								name='country'
								ref='country'
								placeholder='Country'
								label={'Country'}
								ajaxOptionsUrl={countriesJSONPath}
								/>
							<InputText ref='address' name='address' label='Street and number' btw='' />
							<InputText ref='city' name='city' label='City and/or state' btw='' />
							<InputText ref='zip' name='zip' label='Postal or zip code' btw='' />
						</FormFitter>
					</ContentBlock>

					<ContentBlock title='V.A.T.' smallAside={smallAside}>
						<FormFitter className='span100p'>
							<InputCheckbox ref='vatEnabled' name='vatEnabled' label='' onChange={(checked) => { this.setState({ ...this.state, showVAT: checked }); }} className='custom-checkbox--tight'>
								<strong className='custom-checkbox__highlight'>I have a V.A.T number</strong> (Required for companies in the EU who are V.A.T. registered)
							</InputCheckbox>

							<div className={this.state.showVAT ? '' : 'hide'} style={{ width: '144px' }}>
								<InputText ref='vat' name='vat' label='' btw='' placeholder='GB9999999' />
							</div>


						</FormFitter>
					</ContentBlock>

					<ContentBlock title='Voucher' smallAside={smallAside}>
						<FormFitter className='span3 span5-tablet span11-mobile'>
							<InputCheckbox ref='voucher' name='voucher' label='' onChange={(checked) => { this.setState({ ...this.state, showVoucher: checked }); }} className='custom-checkbox--tight'>
								<strong className='custom-checkbox__highlight'>I have a voucher</strong>
							</InputCheckbox>

							<div className={this.state.showVoucher ? '' : 'hide'}>
								<InputText ref='voucherCode' name='voucherCode' label='' btw='' placeholder='Voucher code' />
							</div>
						</FormFitter>
					</ContentBlock>

					<ContentBlock title='' smallAside={smallAside}>
						<FormFitter className='span100p'>
							<InputCheckbox ref='confirmTerms' name='confirmTerms' label='' className='custom-checkbox--tight'>
								<strong className='custom-checkbox__highlight'>Please confirm that you are the representative of the company</strong>
							</InputCheckbox>

						</FormFitter>
					</ContentBlock>

					<ContentBlock className='pixel-pattern pixel-pattern--01' smallAside={smallAside}>
						<div className='span100p'>
							<div className='account-process__button-area'>
								<InputSubmit name='Continue' className='button--dark' disabled={this.state.submitting} waiting={this.state.submitting} />

								{!(this.state.showVoucher || this.props.skipPayment) && (
									<span className='account-process__button-area__button-desc'>
										{translate('account/jobcreate/continueUsingCC')}
									</span>
								)}
								{!(this.state.showVoucher || this.props.skipPayment) && (
									<span className='account-process__button-area__cc-line'>
										Accepted credit/debit cards:
										<div className='account-process__button-area__cc-line__cc-container'>
											<img {...cc1} height='22' width='35' alt='' />
											<img {...cc2} height='22' width='35' alt='' />
											<img {...cc3} height='22' width='35' alt='' />
											<img {...cc4} height='22' width='35' alt='' />
										</div>
									</span>
								)}
							</div>
						</div>
					</ContentBlock>
				</Form>
			</GenericStep>
		);
	}

	renderSummary() {
		let active = (this.props.activeStep > 2);
		let className = 'account-block-content__content__summary';
		if (active) {
			className += ' account-block-content__content__summary--active';
		}

		let contact = (this.refs.contact && typeof this.refs.contact.value === 'function') ? this.refs.contact.value() : '';
		let company = (this.refs.company && typeof this.refs.company.value === 'function') ? this.refs.company.value() : '';

		return (
			<div className={className}>

				{(active && this.props.activeStep !== 4) && (<button className='button account-block-content__content__summary__button' onClick={() => { this.props.goToStep() }}>Edit</button>)}

				<p>
					<strong>{contact}</strong><br/>
					{company}
				</p>

			</div>
		);
	}

	onSubmit(promise) {
		this.mounted && this.setState({
			...this.state,
			submitting: true,
		});

		promise.then((res) => {
			const addedState = { customerInfo: this.refs.form.serialize() };
			if (res.data && res.data.job && res.data.job.slug) {
				addedState.slug = res.data.job.slug;
			}

			this.mounted && this.setState({
				...this.state,
				submitting: false,
			});

			if (this.state.showVoucher) {
				this.props.skipToEnd(addedState);
			} else {
				this.props.onSubmit(promise, addedState);
			}
		})
		.catch((res) => {
			this.mounted && this.setState({
				...this.state,
				submitting: false,
			});
		});
	}

	getRefs() {
		return this.refs;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobCreate/step2.js
 **/